import React from 'react'
import PropTypes from 'prop-types'
import { ThemeColors } from 'src/shared/ui/consts-styles'

const LikeIcon = ({ color = ThemeColors.pureRed }) => {
    return (
        <svg viewBox="0 0 26 23" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M4.40764 0.743311C5.73499 0.117071 7.24688 -0.117712 8.7086 0.055109C10.2971 0.237902 11.8184 0.923491 12.9977 1.97965C14.0149 1.07613 15.2759 0.437073 16.6217 0.162886C18.1327 -0.147387 19.7383 -0.0134964 21.1676 0.560757C22.707 1.17157 24.032 2.28233 24.8886 3.67534C25.703 4.98627 26.085 6.54518 25.9841 8.07543C25.8912 9.67812 25.3634 11.2316 24.6123 12.6498C23.8494 14.0882 22.8558 15.4008 21.7413 16.5965C19.5001 18.9855 16.7975 20.9184 13.9168 22.5079C13.3452 22.8233 12.6522 22.8233 12.0807 22.5078C9.27134 20.9572 6.63326 19.0803 4.42345 16.7731C3.24723 15.5364 2.1972 14.173 1.39801 12.6718C0.607823 11.1844 0.0580358 9.54615 0.00572923 7.8605C-0.0475248 6.52265 0.271431 5.17296 0.92261 3.99582C1.69574 2.58832 2.93461 1.43246 4.40764 0.743311Z"
                fill={color}
            />
        </svg>
    )
}

LikeIcon.propTypes = {
    color: PropTypes.string
}

export default LikeIcon
